
export class Feature {

  name: string;
  level: number;
  path: string[];
  constructor() {
    this.name = '';
    this.level = 0;
    this.path = [];
  }
}


